<script lang="ts" setup>
import { i18n } from '@/i18n';
import { computed, ref, watch } from 'vue';
import GroupListSelectInput from '../GroupListSelectInput.vue';
import InfoModal from '@/corePagesModule/components/InfoModal.vue';

const props = defineProps<{
  modalState: boolean;
  selectInputIndex: number;
}>();

const emits = defineEmits<{
  (e: 'close'): void;
  (e: 'apply', selectedGroupId: string): void; // TODO: 複数選択可能にする場合はここを変更
}>();

//変数
const t = i18n.t;

const selectedGroupId = ref<string>();

watch(
  () => props.modalState,
  (newVal) => {
    if (newVal) {
      selectedGroupId.value = undefined;
    }
  }
);

const isDisabledApplyButton = computed((): boolean => selectedGroupId.value === undefined || selectedGroupId.value === '');
</script>

<template>
  <InfoModal
    :modal-state="modalState"
    :back-button-label="t('キャンセル')"
    :next-button-label="t('追加')"
    :modal-width="764"
    :is-disabled-next-button="isDisabledApplyButton"
    @on-back="emits('close')"
    @on-next="emits('apply', selectedGroupId ?? '')"
  >
    <template #title>{{ t('グループへ追加') }}</template>
    <template #description>{{ t('選択した取引をグループに追加できます。') }}</template>
    <div class="add-group-modal-content__main-content main-content">
      <div class="main-content__container">
        <div class="main-content__title">
          {{ t('グループ名') }}
        </div>
        <!-- TODO: 複数選択可能なSelectInputに置き換える -->
        <GroupListSelectInput
          class="main-content__select-input"
          :select-input-index="selectInputIndex"
          :store-tag="'addAggregateBusinessGroup'"
          @selected-group="(groupId) => (selectedGroupId = groupId)"
        />
      </div>
    </div>
  </InfoModal>
</template>

<style lang="scss" scoped>
.add-group-modal-content {
  height: 100%;
  display: grid;
  grid-template-rows: auto 1fr auto;
  gap: 24px;
}

.main-content {
  background-color: $backgroundDefault;
  border-radius: 8px;

  &__container {
    height: 100%;
    width: 100%;
    padding: 16px;
    display: grid;
    grid-template-rows: repeat(2, auto);
    gap: 8px;
  }

  &__title {
    font-size: 14px;
    font-weight: 400;
    color: $textDefault;
  }

  &__select-input {
    width: 100%;
    box-sizing: border-box;
    background-color: $semanticWhite;
    border-radius: 4px;
    border: 1px solid $borderDefault;
    font-size: 14px;
    font-weight: 400;
    color: $textDefault;
  }
}
</style>
